export default __webpack_public_path__ + "static/media/Reddit.ae961df1.png";